import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { useSetUserLocationAsDefault } from '../../../graphql/apis/user/mutations/hooks/useSetUserLocationAsDefault';
import { UserLocation } from '../../../redux/user/userSlice';
import UserLocationSelector from '../../../components/UserLocationSelector';
import { accountSettingsCardFieldStyles, settingTitleStyles } from './styles';
import { t } from 'i18next';
import spacing from '../../../theme/spacing';
import { colors } from '../../../theme/colors';

const AccountSettingsDefaultLocationField: React.FC = () => {
  const userLocations = useSelector((state: RootState) => state.user.locations);
  const { setLocationAsDefault } = useSetUserLocationAsDefault();

  const handleLocationSelect = (location: UserLocation) => {
    const existingUserLocation = userLocations.find(
      (loc) => loc.id === location.id,
    );

    if (existingUserLocation) {
      const isNotDefault = !Boolean(existingUserLocation.default);
      if (isNotDefault) {
        setLocationAsDefault(location.id);
      }
    }
  };

  return (
    <div style={accountSettingsCardFieldStyles}>
      <div style={{ ...settingTitleStyles, marginBottom: spacing.medium }}>
        {t('accountSettings.defaultLocation')}
      </div>
      <UserLocationSelector
        onLocationSelect={handleLocationSelect}
        selectedLocation={userLocations.find((loc) => loc.default)}
        buttonStyles={{
          border: `1px solid ${colors.backgroundSuperLight}`,
          background: 'transparent',
        }}
      />
    </div>
  );
};

export default AccountSettingsDefaultLocationField;
